/*
*   List of Actions with TYPE that should be passed from administration.reducer.js to categorisation.reducer.js
 */
export const PREFIX = 'ADM_CAT';

export const TYPES = {
    FETCH_CENTER_TYPES:                 `${PREFIX}_FETCH_CENTER_TYPES`,
    FETCH_CENTER_TYPE_MODULES:          `${PREFIX}_FETCH_CENTER_TYPE_MODULES`,
    CENTER_DETAILS_REFRESH:             `${PREFIX}_CENTER_DETAILS_REFRESH`,
    OCCUPATION_DETAILS_REFRESH:         `${PREFIX}_OCCUPATION_DETAILS_REFRESH`,
    CAPABILITY_DETAILS_REFRESH:         `${PREFIX}_CAPABILITY_DETAILS_REFRESH`,
};
